import firebase from "firebase";

const firebaseApp = firebase.initializeApp({
	apiKey: "AIzaSyCuEvWWqV2wDFCJBtvS32oYOuHKZ5jmfvs",
	authDomain: "test-app-501be.firebaseapp.com",
	projectId: "test-app-501be",
	storageBucket: "test-app-501be.appspot.com",
	messagingSenderId: "924097546884",
	appId: "1:924097546884:web:2234b935344c5d079910d1"
})

const db = firebase.firestore();

export default db;